import { useRef } from 'react';
import ModalPop from './ModalPop';
import useDeviceType from '../common/useDeviceType';

const Event = () => {
    const popupRef = useRef<HTMLDivElement>(null);

    const openfunc = () => {
        popupRef.current!.style.display = 'block';
    };

    const closefunc = () => {
        popupRef.current!.style.display = 'none';
    };

    const isMobile = useDeviceType();
    return (
        <>
            <ModalPop popupRef={popupRef} closefnc={closefunc} />

            <div className=" relative w-full h-full">
                <div onClick={openfunc}>
                    <img
                        src={isMobile ? 'images/eventBannerM1.png' : 'images/eventBanner1.png'}
                        alt="집치워드림 견적산출"
                    />
                </div>
                <div onClick={openfunc}>
                    <img
                        src={isMobile ? 'images/eventBannerM2.png' : 'images/eventBanner2.png'}
                        alt="집치워드림 견적산출"
                    />
                </div>
            </div>
        </>
    );
};

export default Event;
